import { useEffect } from "react"

// Track if conversion was already fired in this session

/**
 * VwoConversionScript injects Visual Website Optimizer tracking after signup.
 * Matches the Rails partial at app/views/layouts/client_script_config/_vwo.html.erb
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/client_script_config/_vwo.html.erb
 *
 */
export function VwoConversionScript() {
  useEffect(() => {
    // Load VWO SmartCode
    const vwoScript = document.createElement("script")
    vwoScript.src = "https://dev.visualwebsiteoptimizer.com/lib/580312.js"
    vwoScript.async = true
    document.head.appendChild(vwoScript)

    // Set up conversion tracking
    window._vis_opt_queue = window._vis_opt_queue || []
    window._vis_opt_queue.push(function() {
      if (window._vis_opt_goal_conversion) {
        window._vis_opt_goal_conversion(200)
      }
    })

    return () => {
      // Cleanup if needed
      if (vwoScript.parentNode) {
        vwoScript.parentNode.removeChild(vwoScript)
      }
    }
  }, [])

  return null
}
